define(function (require) {
    "use strict";

    var template = require("personalization-web-agent-templates/widget-templates/widget-list/widgetListView.tmpl");

    var Config = require("personalization-web-agent-config/config.json");

    var Button = require("ui/button/Button");
    var WidgetListItemView = require("personalization-web-agent-views/widget-views/widget-list/WidgetListItemView");

    var WidgetListView = {};
    LE.module('LEPersonalization', function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetListView = Marionette.CompositeView.extend({
            template : template,
            itemView: WidgetListItemView,
            itemViewContainer: ".widget-list-container",
            ui:{
                "addButton": ".add-widget-button",
                "organizeButton": ".organize-widget-button"
            },
            events:{
                "click .add-widget-button" : "_onAddWidgetClick"
            },
            uiComponents: {
                organizeEngagementsBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.organizeButton",
                        permutation: Button.PERMUTATION.BTN_ORGANIZE,
                        initState: Button.STATES.ENABLED,
                        tooltip: LE.translator.translate("LEPersonalization.webAgent.widget.widget.organize.button.tooltip")
                    },
                    events: {
                        click: "_onOrganizeWidgetsClick"
                    }
                }
            },
            /************************** Marionette overriden functions *****************************************/
            initialize : function (options) {
                LEPersonalization.logger.info("Initializing WidgetListView", "WidgetListView:initialize");
                this.vent = options.vent;

                this._bindEvents();
            },

            itemViewOptions: function () {
                return {
                    vent: this.vent
                };
            },

            onRender:function(){
                LEPersonalization.logger.debug("Rendering WidgetListView", "WidgetListView:onRender");
                this._toggleWidgetAddition();
            },

            onClose: function () {
                LEPersonalization.logger.debug("closing WidgetListView", "WidgetListView:onClose");
            },

            /************************** private functions *****************************************************/
            _bindEvents:function(){
                this.listenTo(this.collection, "add remove reset", this._toggleWidgetAddition);
            },

            _onAddWidgetClick: function(){
                if (this.addWidgetsEnabled){
                    this.vent.trigger("widget:add");
                }
            },

            _onOrganizeWidgetsClick: function() {
                this.vent.trigger("widget:organize");
            },

            _toggleWidgetAddition: function(){
                this.addWidgetsEnabled = this.collection.getCustomWidgetsSum() < Config.iFrameWidget.maxNumberOfWidgets;
                this.ui.addButton.toggleClass("disable", !this.addWidgetsEnabled);
                var title = this.addWidgetsEnabled ? LE.translator.translate("LEPersonalization.webAgent.widget.add.button.tooltip") : LE.translator.translate("LEPersonalization.webAgent.widget.add.bubble.text");
                this.ui.addButton.attr("title", title);
            }
        });
    });
    return WidgetListView;
});
